import { ReactNode } from 'react';

import { Flex, Text } from '@spotify-internal/encore-web';

interface SummarySectionProps {
  title: string;
  children: ReactNode;
}

export const SummarySection = ({ title, children }: SummarySectionProps) => (
  <Flex direction="column" gap="tighter-2">
    <Text variant="bodySmallBold" semanticColor="textSubdued">
      {title}
    </Text>
    {children}
  </Flex>
);
